import React, {ReactNode, createContext, useContext, useState} from 'react';

export const DialogContext = createContext<DialogContextValue>({
  isOpen: false,
  open: () => {},
  close: () => {}
});

export type DialogContextValue = {
  isOpen: boolean;
  open: () => void;
  close: () => void;
};

export const DialogContextProvider = ({children}: DialogContextProviderProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);
  return <DialogContext.Provider value={{isOpen, open, close}}>{children}</DialogContext.Provider>;
};

export interface DialogContextProviderProps {
  children: ReactNode;
}

export const useDialogContext = (): DialogContextValue => {
  return useContext<DialogContextValue>(DialogContext);
};
